<template>
  <v-card>
   <v-toolbar color="blue-grey white--text">
      <!-- <v-btn icon class="hidden-xs-only" @click="back()">
        <v-icon>arrow_back</v-icon>
      </v-btn> -->
      <v-toolbar-title class="white--text">รายงานภาระงาน</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title class="subheading white--text"></v-toolbar-title>
    </v-toolbar> 

    <v-card-text>
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex xs12 sm12 md3>
            <v-select
              :loading="loading"
              :items="academicYearItems"
              label="ปี/ภาคการศึกษา"
              v-model="params.academicYear"
              item-value="id"
              item-text="yearSemester"
              outline
              hide-details
              :disabled="loading"
              @change="active = true"
            ></v-select>
          </v-flex>

          <v-flex xs12 sm12 md4 offset-md1>
            <v-radio-group v-model="params.insider" row :disabled="disabled">
              <v-radio label="บุคคลภายใน" value="true"></v-radio>
              <v-radio label="บุคคลภายนอก" value="false"></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex xs12 sm12 md4>
           <v-autocomplete
              :loading="loading"
              :items="personItems"
              label="อาจารย์"
              v-model="params.person"
              item-value="id"
              item-text="fullname"
              outline
              hide-details
              clearable
              :disabled="loading"
            ></v-autocomplete>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout row wrap class="mt-5">
          <v-flex xs12 sm12 md2>
            <v-menu
              ref="menu"
              :close-on-content-click="false"
              v-model="menu"
              :nudge-right="40"
              :return-value.sync="params.date"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                :value="date(params.date)"
                label="วันที่ออกรายงาน"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="params.date" @input="$refs.menu.save(params.date)" no-title locale="th-Th"></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex xs12 sm12 md4 offset-md1>
            <v-autocomplete
              :loading="loading"
              v-model="params.endorserA"
              :items="personItems"
              color="blue"
              item-value="fullname"
              item-text="fullname"
              label="หัวหน้าสำนักงานวิชาศึกษาทั่วไป"
              :rules="[v => !!v || 'ไม่สามารถเป็นค่าว่าง']" 
              required
              :disabled="loading"
              hide-details
            ></v-autocomplete>
          </v-flex>

          <v-flex xs12 sm12 md4 offset-md1>
            <v-autocomplete
              :loading="loading"
              v-model="params.endorserB"
              :items="personItems"
              color="blue"
              item-value="fullname"
              item-text="fullname"
              label="คณบดีคณะศิลปศาสตร์"
              :rules="[v => !!v || 'ไม่สามารถเป็นค่าว่าง']" 
              required
              :disabled="loading"
              hide-details
            ></v-autocomplete>
          </v-flex>
        </v-layout>


      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-slide-x-transition mode="out-in">
        <v-btn
          color="info"
          :loading="loading"
          :disabled="loading"
          target="_new"
          @click="loader = 'loading'"
          :href="printoutUrl"
          v-if="complete"
        >
          <v-icon left dark>cloud_download</v-icon> ส่งออกข้อมูล
        </v-btn>
      </v-slide-x-transition>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import config from '@/config/index'
import swal from 'sweetalert2'
import moment from 'moment'

export default {
  data () {
    return {
      active: false,
      disabled: false,
      loader: null,
      loading: false,
      academicYearItems: [],
      menu: null,
      params: {
        academicYear: null,
        date: null,
        endorserA: null,
        endorserB: null,
        insider: 'true',
        person: null
      }
    }
  },
  mounted () {},
  computed: {
    ...mapGetters ({
      personItems: 'person/personItems',
      token: 'token'
    }),
    printoutUrl () {
      return `${config.serverURI}/reports/printout/workload?academicYear=${this.params.academicYear}&insider=${this.params.insider}&date=${this.params.date}&endorserA=${this.params.endorserA}&endorserB=${this.params.endorserB}&person=${this.params.person}&access_token=${this.token}`
    },
    complete () {
      if(this.params.academicYear && this.params.date && this.params.endorserA && this.params.endorserB ) {
        return true
      } else {
        return false
      }
    }
  },
  mounted () {
    this.fetchAcademicYears ()
    if(this.personItems.length == 0) this.$store.dispatch('person/fetchPersonItems')
  },
  methods: {
    date (val) {
      return val ? this.$options.filters.formatFullDate(val) : null
    },
    fetchAcademicYears () {
      this.loading = true
      this.$store.dispatch("academicYear/loadItems")
        .then((response) => {
          this.academicYearItems = response.data
          this.loading = false
        }).catch((error)=>{
          console.log('reload', error)
          this.loading = false
        })
    }
  },
  watch: {
    loader () {
      const l = this.loader
      this[l] = !this[l]

      setTimeout(() => (this[l] = false), 3000)

      this.loader = null
    },
    'params': {
      handler (val) {
        if(val.person){
          this.disabled = true
        } else {
          this.disabled = false
        }

      },
      deep: true
    }
  }
}
</script>

<style scoped>
  .boxes {
    min-width: 400px;
  }
</style>


// WEBPACK FOOTER //
// src/components/reports/workload/index.vue